import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'

import CertWidgetSkeleton from './CertWidgetSkeleton'
import CertList from './subcomponents/CertList/CertList'

const CertWidget = ({ certifications }) => {
  return (
    <CertWidgetSkeleton
      headerSection={t('Certificates')}
      contentSection={<CertList certifications={certifications} />}
    />
  )
}

CertWidget.propTypes = {
  certifications: PropTypes.array.isRequired,
}

export default CertWidget
